import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';
import {AccountSortField as AccountSortFields} from 'src/openapi/admin/models/AccountSortField';

import type {ManagedAccountsSearchCriteria} from '../typedef';
import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import type {GetManagedAccountIdsRequestFilters} from 'src/openapi/admin/models/GetManagedAccountIdsRequestFilters';


export const accountSearchResultStateSlice = getCachedTableStateSlice<
    ManagedAccountsSearchCriteria,
    AccountSortField,
    GetManagedAccountIdsRequestFilters & AccountSearchFiltering
>('assignedAccountsSearchResultState', AccountSortFields.ACCOUNT_NAME);

export const accountSearchResultStateActions = accountSearchResultStateSlice.actions;
export const accountSearchResultStateSelector:
CachedTableStateSelector<
    ManagedAccountsSearchCriteria,
    AccountSortField,
    GetManagedAccountIdsRequestFilters & AccountSearchFiltering
> = state => state.userPage.tabs.assignedAccounts.state;
